import { TSearchParams } from '@/_types/route-params';

export const getIsSideMode = ({ isSideMode }: TSearchParams): boolean =>
  isSideMode === 'true';
